import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shared/components/ui/select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpArrowDown } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import React from 'react';

interface ProductToLocate {
  id: string;
  name: string;
  code: string;
  quantity: number;
  totalQuantity: number;
  location?: string;
  image?: string;
}

interface ProductsToLocateHeaderProps {
  products: ProductToLocate[];
  currentSort: string;
  onSort: (sortBy: string) => void;
  searchQuery?: string;
  onSearchChange?: (value: string) => void;
}

type SortOption = {
  value: string;
  label: string;
};

export const ProductsToLocateHeader: React.FC<ProductsToLocateHeaderProps> = ({ products, currentSort, onSort }) => {
  const { t } = useTranslation('locationordersDetailModule');

  const sortOptions: SortOption[] = [
    { value: 'more_qty', label: t('ui.sort.more_qty', { defaultValue: 'Cantidad de mayor a menor' }) },
    { value: 'less_qty', label: t('ui.sort.less_qty', { defaultValue: 'Cantidad de menor a mayor' }) },
    { value: 'location_az', label: t('ui.sort.location_az', { defaultValue: 'Ubicación de A a Z' }) },
    { value: 'location_za', label: t('ui.sort.location_za', { defaultValue: 'Ubicación de Z a A' }) },
    { value: 'name_az', label: t('ui.sort.name_az', { defaultValue: 'Nombre de A a Z' }) },
    { value: 'name_za', label: t('ui.sort.name_za', { defaultValue: 'Nombre de Z a A' }) },
  ];

  const currentLabel = sortOptions.find((option) => option.value === currentSort)?.label || 'Seleccionar ordenación';

  return (
    <div className="flex items-center justify-between mb-4 flex-shrink-0">
      <h2 className="text-lg font-semibold text-foreground flex items-center space-x-2">
        <span className="text-orange-600 dark:text-orange-400">
          {t('ui.products_to_locate', { defaultValue: 'Productos pendientes' })}
        </span>
        <span className="text-sm text-muted-foreground">({products.length})</span>
      </h2>

      {/* Versión móvil - Solo icono */}
      <div className="block lg:hidden">
        <Select value={currentSort} onValueChange={onSort}>
          <SelectTrigger className="w-10 h-10 p-0 border-0 bg-transparent hover:bg-muted/50 transition-colors">
            <div className="flex items-center justify-center w-full h-full">
              <FontAwesomeIcon icon={faArrowUpArrowDown} className="w-4 h-4 text-muted-foreground" />
            </div>
          </SelectTrigger>
          <SelectContent>
            {sortOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Versión desktop - Desplegable completo */}
      <div className="hidden lg:block">
        <Select value={currentSort} onValueChange={onSort}>
          <SelectTrigger className="w-[220px]">
            <SelectValue placeholder="Seleccionar ordenación">{currentLabel}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {sortOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
